import { Twitter } from '../../../../../../components/Icons/Twitter';
import { Facebook } from '../../../../../../components/Icons/Facebook';
import { LinkedIn } from '../../../../../../components/Icons/LinkedIn';
import { WhatsApp } from '../../../../../../components/Icons/WhatsApp';
import { isMobileAny } from '../../../../../../utils/device';
import { EnvelopeO } from '../../../../../../components/Icons/EnvelopeO';
import React from 'react';
import { getPagePath } from '../utils';

export const usePublicJobDetailShareData = (title: string) => {
	const url = window.encodeURIComponent(getPagePath());
	const postTitle = window.encodeURIComponent(title);

	return [
		{
			type: 'twitter',
			icon: <Twitter />,
			shareUrl: `https://twitter.com/share?url=${url}`,
		},
		{
			type: 'facebook',
			icon: <Facebook />,
			shareUrl: `https://facebook.com/sharer/sharer.php?u=${url}`,
		},
		{
			type: 'linkedin',
			icon: <LinkedIn />,
			shareUrl: `https://www.linkedin.com/shareArticle?mini=true&url=${url}&title=${postTitle}`,
		},
		{
			type: 'whatsApp',
			icon: <WhatsApp />,
			shareUrl: isMobileAny ? `whatsapp://send?text=${url}` : `https://web.whatsapp.com/send?text=${url}`,
		},
		{
			type: 'email',
			icon: <EnvelopeO />,
			shareUrl: `mailto:?subject=${title}&body=${url}`,
			target: 'self',
		},
	];
};
